import { PropsWithChildren } from 'react';
import { SupportContact } from '@/components/domain/common/support/SupportContact';
import './AuthLayout.scss';

export const AuthLayout: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="auth__layout">
      {/* One centred column keeps the strip right under the page's card or alert. */}
      <div className="flex w-full flex-col items-center gap-4">
        {children}
        <div className="w-full rounded-xl border border-base-light bg-white px-6 py-3 shadow-card min-[769px]:w-fit">
          <SupportContact layout="inline" />
        </div>
      </div>
    </div>
  );
};
